"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const moment_1 = __importDefault(require("moment"));
const react_router_dom_1 = require("react-router-dom");
const icons_1 = require("@ant-design/icons");
const constants_1 = require("../../../assets/constants/constants");
const PaymentForm_1 = __importDefault(require("../../../components/paymentForm/PaymentForm"));
const SuiteTabs_1 = __importDefault(require("../../../components/suiteCollapse/SuiteTabs"));
const underline_1 = __importDefault(require("../../../components/underline"));
const FormSuite_1 = require("../../../hooks/FormSuite");
const PaymentService_1 = __importDefault(require("../../../services/PaymentService"));
const PaymentStyled_1 = require("./PaymentStyled");
const ModalPaymentErrorStyled_1 = require("../../../components/modalAnt/genericModal/ModalPaymentErrorStyled");
const ModalPaymentErrorContent_1 = __importDefault(require("../../../components/modalAnt/genericModal/ModalPaymentErrorContent"));
const helpers_1 = require("../../../utils/helpers");
const BookingService_1 = __importDefault(require("../../../services/BookingService"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const ModalRedirectPaymentContent_1 = __importDefault(require("../../../components/modalAnt/genericModal/ModalRedirectPaymentContent"));
const users_1 = require("../../../utils/users");
const TimeLeft_1 = __importDefault(require("../../../components/timeLeft/TimeLeft"));
const DisplayEmailAndLogin_1 = __importDefault(require("../../../components/pages/paymentBooking/DisplayEmailAndLogin"));
const FacebookPixelLocation_1 = require("../../../components/facebookPixelLocation/FacebookPixelLocation");
const BookingRequestBuilder_1 = __importDefault(require("../../../dtos/builder/BookingRequestBuilder"));
const useHubspot_1 = __importDefault(require("../../../utils/useHubspot"));
const user_requests_1 = require("../../../dataSource/user_requests");
const format_1 = require("../../../utils/format");
const RefundProtect_1 = require("../../../components/refundProtect/RefundProtect");
const dates_1 = require("../../../utils/dates");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const data_repository_1 = require("../../../dataSource/data_repository");
const validations_1 = require("../../../utils/validations");
const storage_1 = require("../../../utils/storage");
const ConfirmValuesContext_1 = require("../context/ConfirmValuesContext");
const PaymentUtils_1 = require("../utils/PaymentUtils");
const Text_1 = __importDefault(require("../../../components/shared/Text"));
require("./Payment.scss");
const PagseguroContext_1 = require("../../../hooks/PagseguroContext");
const firstMessageLoadingPayment = 'Estamos confirmando sua reserva...';
const secondMessageLoadingPayment = 'O seu apê está sendo preparado...';
const thirdMessageLoadingPayment = 'Aguarde mais alguns segundos...';
const Payment = ({ disabled }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const arrayID = ['1'];
    const { form: formSuite } = (0, FormSuite_1.useFormSuit)();
    const [formPayment] = antd_1.Form.useForm();
    const [disableForm, setDisableForm] = (0, react_1.useState)(true);
    const [formWithError, setFormWithError] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [modalStateError, setModalStateError] = (0, react_1.useState)(false);
    const [modalStateErrorDescription, setModalStateErrorDescription] = (0, react_1.useState)('');
    const [modalStateRedirect, setModalStateRedirect] = (0, react_1.useState)(false);
    const [modalStateRedirectPix, setModalStateRedirectPix] = (0, react_1.useState)(false);
    const [timeLeftServer, setTimeLeftServer] = (0, react_1.useState)(0);
    const [startTimer, setStartTimer] = (0, react_1.useState)(false);
    const [redirectLink, setRedirectLink] = (0, react_1.useState)('');
    const [paymentEnabled, setPaymentEnabled] = (0, react_1.useState)(true);
    const [refundProtectEnabled, setRefundProtectEnabled] = (0, react_1.useState)(false);
    const [showRefundComponent, setShowRefundComponent] = (0, react_1.useState)(false);
    const [userEmail, setUserEmail] = (0, react_1.useState)(undefined);
    const [needDebitPhoneBR, setNeedDebitPhoneBR] = (0, react_1.useState)(false);
    const [needPaymentDocCPF, setNeedPaymentDocCPF] = (0, react_1.useState)(false);
    const [sendPurchasePrice, setSendPurchasePrice] = (0, react_1.useState)(0);
    const [reserveInfo, setReserveInfo] = (0, react_1.useState)(confirmValuesContext.confirmValues);
    const history = (0, react_router_dom_1.useHistory)();
    const [filledGuestsNumber, setFilledGuestsNumber] = (0, react_1.useState)(0);
    const { dispatch } = (0, useHubspot_1.default)();
    const match = (0, react_router_dom_1.useRouteMatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const { abandonedCartToken } = match === null || match === void 0 ? void 0 : match.params;
    const userLogged = !!(0, users_1.getAccessToken)();
    const [messageLoading, setMessageloading] = (0, react_1.useState)('Estamos confirmando sua reserva...');
    const { selectedInstallment } = (0, PagseguroContext_1.usePagseguro)();
    const paymentRef = (0, react_1.useRef)(null);
    const confirmReserve = (0, react_1.useCallback)(() => {
        setTimeout(() => {
            localStorage.setItem('last_page_before_confirmed_payment', (0, helpers_1.encrypty)(RoutesPaths_1.routesPaths.paymentBooking));
            history.push(RoutesPaths_1.routesPaths.confirmedBooking);
        }, 1000);
    }, [history]);
    const redirectToLogin = () => {
        const lastUrl = location.pathname + location.search;
        (0, users_1.setLastPageBeforeLogin)(lastUrl);
        history.push(RoutesPaths_1.routesPaths.login);
    };
    const sendCheckoutCreditPayload = (0, react_1.useCallback)((card) => __awaiter(void 0, void 0, void 0, function* () {
        const paymentService = new PaymentService_1.default(formPayment, formSuite);
        const payload = yield paymentService.mountCheckoutCreditPayload(card, confirmValuesContext.confirmValues);
        return paymentService.sendCheckoutPayload(payload);
    }), [confirmValuesContext.confirmValues, formPayment, formSuite]);
    const sendCheckoutDebitPayload = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const paymentService = new PaymentService_1.default(formPayment, formSuite);
        const payload = yield paymentService.mountCheckoutDebitPayload(confirmValuesContext.confirmValues);
        return paymentService.sendCheckoutPayload(payload);
    }), [confirmValuesContext.confirmValues, formPayment, formSuite]);
    const sendCheckoutPixPayload = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const paymentService = new PaymentService_1.default(formPayment, formSuite);
        const payload = yield paymentService.mountCheckoutPixPayload(confirmValuesContext.confirmValues);
        return paymentService.sendCheckoutPayload(payload);
    }), [confirmValuesContext.confirmValues, formPayment, formSuite]);
    const Active = (0, react_1.useCallback)(() => {
        const validate = formSuite.validateFields(['email']);
        const field = formSuite.getFieldValue('email');
        if (field.length > constants_1.MIN_EMAIL_LENGHT) {
            validate.then(() => setDisableForm(false)).catch(() => setDisableForm(true));
        }
        else {
            setDisableForm(true);
        }
    }, [formSuite]);
    const discoverFormsToExpand = (errorFields) => {
        const formsToExpand = [];
        errorFields.forEach((error) => {
            const targetForm = error.name[1];
            !formsToExpand.includes(targetForm) && formsToExpand.push(targetForm);
        });
        return formsToExpand;
    };
    const validate = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const promise1 = new Promise((resolve, reject) => {
            formPayment
                .validateFields()
                .then(() => __awaiter(void 0, void 0, void 0, function* () {
                resolve(true);
            }))
                .catch(err => {
                reject(err);
            });
        });
        const promise2 = new Promise((resolve, reject) => {
            formSuite
                .validateFields()
                .then(() => {
                resolve(true);
            })
                .catch((err) => {
                setFormWithError(discoverFormsToExpand(err.errorFields));
                reject(err);
            });
        });
        return Promise.all([promise1, promise2]).catch(err => {
            console.error(err);
            throw new Error(`Ops deu Errado: Verifique os campos, por favor.`);
        });
    }), [formPayment, formSuite]);
    const mountCardToken = (0, react_1.useCallback)(() => {
        const splitDueDate = formPayment.getFieldValue('dueDate').split('/');
        const brand = formPayment.getFieldValue('brand');
        const cardNumber = formPayment.getFieldValue('cardNumber').replace(constants_1.REMOVE_SPACES_REGEX, '');
        const cvv = formPayment.getFieldValue('cvv');
        return {
            brand,
            cardNumber,
            cvv,
            expirationMonth: splitDueDate[0],
            expirationYear: splitDueDate[1],
        };
    }, [formPayment]);
    const sendCoupon = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const paymentService = new PaymentService_1.default();
            const { coupon } = confirmValuesContext.confirmValues;
            if (coupon && coupon.phrase) {
                const invoiceDiscout = {
                    description: 'Cupom de desconto',
                    status: 'ok',
                    qty: '-1',
                    price: Number(coupon.discountValue),
                    vatRate: '0',
                    type: coupon.type,
                    invoiceeId: '',
                };
                const { bookId, refundPrice } = confirmValuesContext.confirmValues;
                const invoice = {
                    bookId,
                    guestVoucher: coupon.phrase,
                    invoice: invoiceDiscout,
                    withRefundProtect: !!refundPrice,
                    refundPrice: Number((0, format_1.getFormattedDouble)(refundPrice).replace('.', '').replace(',', '.')),
                };
                yield paymentService.sendCouponDetails(invoice);
            }
        }
        catch (e) {
            throw new Error(e.data);
        }
    }), [confirmValuesContext.confirmValues]);
    const showModalError = (0, react_1.useCallback)(errors => {
        setModalStateError(true);
        if (errors) {
            const foundErrorMessage = !!errors.find((pagseguroError) => {
                const foundError = constants_1.PAYMENT_ERROR.find((errorItem) => errorItem.code === pagseguroError.code);
                if (foundError) {
                    setModalStateErrorDescription(foundError.message);
                    return true;
                }
                return false;
            });
            if (foundErrorMessage) {
                return;
            }
        }
        setModalStateErrorDescription('');
    }, []);
    const sendCheckout = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const politics = {
            allowStore: formSuite.getFieldValue('acceptStoreData') || false,
            emailOffers: formSuite.getFieldValue('acceptOffers') || false,
            email: formSuite.getFieldValue('email'),
        };
        (0, PaymentUtils_1.ReactGAFinalizarReserva)();
        try {
            yield (0, user_requests_1.editMyPolitics)(politics);
            const response = yield validate();
            const type = formPayment.getFieldValue('paymentType');
            if (response[0] === true && response[1] === true) {
                const formValuesParam = JSON.parse((0, storage_1.getStorageValue)(users_1.keyVariables.paymentGuestValues) || '{}');
                const formValues = formSuite.getFieldsValue();
                const hubspotParams = BookingRequestBuilder_1.default.hubspotFormBuilder({
                    formValues: Object.assign(Object.assign({}, formValuesParam), { acceptOffers: formValues.acceptOffers }),
                    key: 0,
                    pageName: 'Pagamento',
                    pageUri: window.location.href,
                    guestsQty: confirmValuesContext.confirmValues.guestsQty,
                    paymentMethod: type,
                    confirmValues: confirmValuesContext.confirmValues,
                });
                dispatch(hubspotParams);
                const { coupon, bookId } = confirmValuesContext.confirmValues;
                switch (type) {
                    case constants_1.PAYMENT_TYPE.CREDIT: {
                        const card = mountCardToken();
                        setLoading(true);
                        yield sendCheckoutCreditPayload(card)
                            .then(response => {
                            if (coupon && coupon.phrase) {
                                sendCoupon();
                            }
                            setLoading(false);
                            confirmValuesContext.setConfirmValuesOnStorage(Object.assign(Object.assign({}, confirmValuesContext.confirmValues), { selectedInstallment }));
                            confirmReserve();
                            (0, FacebookPixelLocation_1.sendFBPixel)('PaymentInfoTrack', 'AddPaymentInfo');
                            const formattedValue = response.checkout.grossAmount;
                            (0, FacebookPixelLocation_1.sendFBPixel)('Purchase', {
                                content_type: confirmValuesContext.confirmValues.suite.propId,
                                content_ids: confirmValuesContext.confirmValues.suite.roomId,
                                value: formattedValue.toFixed(2),
                                currency: 'BRL',
                                checkin_date: confirmValuesContext.confirmValues.firstNight,
                                checkout_date: confirmValuesContext.confirmValues.lastNight,
                            });
                            (0, PaymentUtils_1.sendToConvertionGoogleAnalytics)(Number(sendPurchasePrice.toFixed(2)), bookId, confirmValuesContext.confirmValues.suite.buildingName);
                        })
                            .catch(err => {
                            var _a, _b, _c;
                            showModalError(((_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errorContent) === null || _c === void 0 ? void 0 : _c.errors) || null);
                            setLoading(false);
                            throw new Error(`Ops deu Errado: ${err}`);
                        });
                        break;
                    }
                    case constants_1.PAYMENT_TYPE.DEBIT: {
                        setLoading(true);
                        yield sendCheckoutDebitPayload()
                            .then(response => {
                            setRedirectLink(response.checkout.paymentLink);
                            setLoading(false);
                            setModalStateRedirect(true);
                            setSendPurchasePrice(response.checkout.grossAmount);
                        })
                            .catch(err => {
                            var _a, _b, _c;
                            showModalError(((_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errorContent) === null || _c === void 0 ? void 0 : _c.errors) || null);
                            setLoading(false);
                            throw new Error(`Ops deu Errado: ${err}`);
                        });
                        break;
                    }
                    case constants_1.PAYMENT_TYPE.PIX: {
                        setLoading(true);
                        yield sendCheckoutPixPayload()
                            .then(response => {
                            setRedirectLink(response.checkout.paymentLink);
                            setLoading(false);
                            setModalStateRedirectPix(true);
                            setSendPurchasePrice((0, PaymentUtils_1.pixGrossAmount)(response.checkout));
                        })
                            .catch(err => {
                            var _a, _b, _c;
                            showModalError(((_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errorContent) === null || _c === void 0 ? void 0 : _c.errors) || null);
                            setLoading(false);
                            throw new Error(`Ops deu Errado: ${err}`);
                        });
                        break;
                    }
                    default:
                        throw Error('Payment Type Invalid');
                }
            }
        }
        catch (err) {
            throw new Error(err.data);
        }
    }), [
        formSuite,
        validate,
        formPayment,
        confirmValuesContext.confirmValues,
        dispatch,
        mountCardToken,
        sendCheckoutCreditPayload,
        confirm,
        sendPurchasePrice,
        sendCoupon,
        showModalError,
        sendCheckoutDebitPayload,
        sendCheckoutPixPayload,
    ]);
    const setBookingTimer = (0, react_1.useCallback)((bookingId, isFromBookingInChart) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield BookingService_1.default.getTimeLeft(bookingId, isFromBookingInChart);
        const { booking: { timeLeft }, } = response;
        if (timeLeft !== null) {
            const newTime = timeLeft === 0 ? 5 : +timeLeft;
            setTimeLeftServer(newTime);
        }
    }), []);
    const handleRedirectButton = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const { coupon, bookId } = confirmValuesContext.confirmValues;
        if (coupon && coupon.phrase) {
            yield sendCoupon();
        }
        const redirect = window.open(redirectLink, '_blank');
        redirect === null || redirect === void 0 ? void 0 : redirect.focus();
        setModalStateRedirect(false);
        setModalStateRedirectPix(false);
        confirmReserve();
        (0, FacebookPixelLocation_1.sendFBPixel)('PaymentInfoTrack', 'AddPaymentInfo');
        (0, FacebookPixelLocation_1.sendFBPixel)('Purchase', {
            content_type: confirmValuesContext.confirmValues.suite.propId,
            content_ids: confirmValuesContext.confirmValues.suite.roomId,
            value: sendPurchasePrice.toFixed(2),
            currency: 'BRL',
            checkin_date: confirmValuesContext.confirmValues.firstNight,
            checkout_date: confirmValuesContext.confirmValues.lastNight,
        });
        (0, PaymentUtils_1.sendToConvertionGoogleAnalytics)(Number(sendPurchasePrice.toFixed(2)), bookId, confirmValuesContext.confirmValues.suite.buildingName);
    }), [confirm, confirmValuesContext.confirmValues, redirectLink, sendCoupon, sendPurchasePrice]);
    // Insere os dados no formulário de pagamento
    const fillPaymentData = (confirmValues, // Dados do pagamento
    paymentGuestValues, // Dados do usuário
    isFromStorage) => {
        setReserveInfo(confirmValues);
        // Se estiver deslogado, desabilita o formulário
        if (!userLogged) {
            setDisableForm(true);
            setPaymentEnabled(true);
            return;
        }
        if (isFromStorage) {
            const totalGuestsStorage = (0, helpers_1.decrypty)(localStorage.getItem('XP360:filledGuestsNumber'));
            if (totalGuestsStorage && (0, validations_1.isNumeric)(totalGuestsStorage))
                setFilledGuestsNumber(parseInt(totalGuestsStorage, 10));
        }
        // Recupera o e-mail do usuário
        const userData = (0, users_1.getUserData)();
        if (!userData.email) {
            (0, users_1.removeUserFromStorage)();
            redirectToLogin();
            return;
        }
        setUserEmail(userData.email);
        const formValues = formSuite.getFieldsValue();
        if (!paymentGuestValues) {
            // O usuário ainda não preencheu o formulário, então preenche inicialmente com os dados do cadastro
            // Busca os dados que existem no cadastro
            const suites = (0, PaymentUtils_1.getInitialSuiteValuesFromUserData)(formValues, userData);
            // Carrega os valores nos campos do formulário
            formSuite.setFieldsValue(Object.assign(Object.assign({}, formValues), { suites, email: userData.email }));
            setFormWithError([0]); // Faz com que formulário dos hóspedes inicie aberto
        }
        else {
            // Já possui dados para preencher o formulário
            // Carrega os valores nos campos do formulário
            formSuite.setFieldsValue(Object.assign(Object.assign(Object.assign({}, formValues), paymentGuestValues), { email: userData.email }));
            // É obrigatório um telefone BR e um CPF para poder pagar com o PagSeguro
            // Verifica se precisa adicionar os campos obrigatórios para o pagamento
            const { ddiRequired, documentTypeGuestRequired } = paymentGuestValues.suites[0];
            setNeedDebitPhoneBR(ddiRequired !== '55');
            setNeedPaymentDocCPF(documentTypeGuestRequired !== 'CPF');
            if (isFromStorage) {
                // Por já ter os dados do hóspede confirmados, libera os próximos passos
                setDisableForm(false);
                setRefundProtectEnabled(true);
                setShowRefundComponent(true);
                setPaymentEnabled(true);
            }
            else {
                // Por ter vindo da requisição de carrinho abandonado, obriga o usuário a confirmar os dados
                // Todos os campos já vem preenchidos, mas é necessário clicar em salvar para liberar os próximos passos
                setFormWithError([0]); // Faz com que formulário dos hóspedes inicie aberto
            }
        }
        // Facebook Pixel
        (0, FacebookPixelLocation_1.sendFBPixel)('InitiateCheckout', {
            content_type: confirmValues.suite.propId,
            content_ids: confirmValues.suite.roomId,
            checkin_date: (0, dates_1.formatDateToView)((0, moment_1.default)(confirmValues.initialDate).toString()),
            checkout_date: (0, dates_1.formatDateToView)((0, moment_1.default)(confirmValues.finalDate).toString()),
        });
        // Habilita o formulário
        setDisableForm(false);
        setLoading(false);
    };
    const handlingAbandonedCart = () => {
        // Busca os dados do booking
        const endPoint = `/booking-in-chart/token-validation/${abandonedCartToken}`;
        setLoading(true);
        (0, data_repository_1.get)({ url: endPoint, query: {}, params: {}, clientOptions: {} })
            .then((response) => {
            var _a;
            if (!response.isError) {
                // Atualiza o timer do booking
                const { timeLeft } = response.data;
                const newTime = timeLeft === 0 ? 5 : +timeLeft;
                setTimeLeftServer(newTime);
                const { booking } = response.data;
                const paymentGuestValuesString = (0, storage_1.getStorageValue)(users_1.keyVariables.paymentGuestValues);
                // Verifica se tem dados do booking e do formulário no storage e se é do mesmo booking do token
                if (confirmValuesContext.confirmValues &&
                    paymentGuestValuesString && // Previne dados em branco se entra pelo token e atualiza a página sem salvar
                    ((_a = confirmValuesContext.confirmValues) === null || _a === void 0 ? void 0 : _a.bookId) === (booking === null || booking === void 0 ? void 0 : booking.id)) {
                    const paymentGuestValues = paymentGuestValuesString ? JSON.parse(paymentGuestValuesString) : null;
                    fillPaymentData(confirmValuesContext.confirmValues, paymentGuestValues, true);
                    return;
                }
                // Limpa o storage de booking
                (0, helpers_1.handleCleanBookingStorage)();
                // Trata os valores necessários para criar o novo confirmValues
                const initialDate = (0, moment_1.default)(booking.firstNight, 'yyyy-MM-DD');
                const finalDate = (0, moment_1.default)(booking.lastNight, 'yyyy-MM-DD').add(1, 'days');
                const dailyQtyString = (0, format_1.zeroPad)(finalDate.diff(initialDate, 'days'), 2);
                const guestsQty = booking.numAdult;
                const guestsQtyString = (0, format_1.zeroPad)(guestsQty, 2);
                const { cleaningFee } = booking;
                const cleaningFeeFormated = (0, format_1.getFormattedDouble)(cleaningFee);
                // Number do valor total (valor da diária + valor da taxa de limpeza)
                const totalPrice = Number(booking.price) + Number(cleaningFee);
                const amount = (0, format_1.getFormattedDouble)(totalPrice).toString().split(',');
                const totalNumber = amount[0];
                const totalDecimal = (0, format_1.zeroPad)(amount[1], 2);
                // String formatada do valor total
                const suitePrice = (0, format_1.getFormattedDouble)(booking.price);
                const newConfirmValues = {
                    initialDate,
                    finalDate,
                    initialDay: initialDate.format('DD'),
                    initialDayWeek: initialDate.locale('pt-br').format('ddd'),
                    initialmonth: initialDate.locale('pt-br').format('MMM'),
                    finalDay: finalDate.format('DD'),
                    finalDayWeek: finalDate.locale('pt-br').format('ddd'),
                    finalmonth: finalDate.locale('pt-br').format('MMM'),
                    suiteQtyString: constants_1.DEFAULT_SUITE_QTDY,
                    dailyQtyString,
                    guestsQtyString,
                    suitePrice,
                    cleaningFee,
                    totalNumber,
                    totalDecimal,
                    firstNight: initialDate.format('yyyy-MM-DD'),
                    lastNight: finalDate.format('yyyy-MM-DD'),
                    suite: {},
                    quantity: 1,
                    guestsQty,
                    // Valor bruto
                    price: booking.price,
                    priceValueFormatted: (0, format_1.getFormattedDouble)(booking.price),
                    // fator multiplicador do dia
                    discountPercent: 0,
                    // Preço com a aplicação do fator multiplicador do dia
                    priceGross: booking.price,
                    priceGrossFormatted: (0, format_1.getFormattedDouble)(booking.price),
                    originalTotalPrice: totalPrice,
                    totalPrice,
                    bookId: booking.id,
                    cleaningFeeFormated,
                    isFromBookingInChart: true,
                };
                // Apenas esses 4 campos são obrigatórios no suite para utilizar a página de pagamento
                const suite = {
                    propId: booking.propId,
                    roomId: booking.roomId,
                    suiteTitle: booking.roomName,
                    buildingName: booking.buildingName,
                };
                newConfirmValues.suite = suite;
                // Salva os dados tratados no storage
                localStorage.setItem('XP360:suite_features', (0, helpers_1.encrypty)(JSON.stringify(suite.amenities)));
                localStorage.setItem('XP360:suite_roomId', (0, helpers_1.encrypty)(String(booking.roomId)));
                localStorage.setItem(constants_1.LOCAL_STORAGE.bookingId, (0, helpers_1.encrypty)(booking.id));
                localStorage.setItem('XP360:beds_bookId', (0, helpers_1.encrypty)(String(booking.bookId)));
                // Quantidade de hóspedes salvos já preenchidos e validados
                localStorage.setItem('XP360:filledGuestsNumber', (0, helpers_1.encrypty)('0'));
                setFilledGuestsNumber(0);
                // Atualiza o context
                confirmValuesContext.setConfirmValuesOnStorage(newConfirmValues);
                const custom9 = booking.custom9 ? JSON.parse(booking.custom9) : null;
                const formValues = formSuite.getFieldsValue();
                const paymentGuestValues = custom9
                    ? (0, PaymentUtils_1.convertCustom9ToPaymentGuestValues)(formValues, custom9, booking.numAdult, booking.custom5)
                    : null;
                // Insere os dados no formulário de pagamento
                fillPaymentData(newConfirmValues, paymentGuestValues, false);
            }
            else {
                // handleErrorMessages(data);
                switch (response.code) {
                    case -22000:
                        message_utils_1.default.error({
                            message: 'Este link está expirado',
                            description: '',
                        });
                        break;
                    case -22001:
                        message_utils_1.default.error({
                            message: 'Infelizmente este quarto não está mais disponível na data selecionada',
                            description: '',
                        });
                        break;
                    default:
                        message_utils_1.default.error({
                            message: 'Não foi possível recuperar a reserva',
                            description: '',
                        });
                        break;
                }
                history.push(RoutesPaths_1.routesPaths.root);
            }
        })
            .catch(err => {
            console.error('Erro ', err);
            message_utils_1.default.error({
                message: 'Ocorreu um erro na requisição',
                description: 'Tente novamente mais tarde',
            });
            history.push(RoutesPaths_1.routesPaths.root);
            setLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        if (timeLeftServer > 0) {
            setStartTimer(true);
        }
    }, [timeLeftServer]);
    (0, react_1.useEffect)(() => {
        var _a;
        // Tratamento de carrinho abandonado
        if (abandonedCartToken) {
            // Caso não esteja logado redireciona para o login
            if (!(0, users_1.checkUserIsAuth)()) {
                redirectToLogin();
                return;
            }
            // Realiza o tratamento dos dados para carrinho abandonado
            handlingAbandonedCart();
        }
        else {
            // Reserva comum, não é carrinho abandonado. Trabalha direto com os dados do storage
            const paymentGuestValuesString = (0, storage_1.getStorageValue)(users_1.keyVariables.paymentGuestValues);
            const paymentGuestValues = paymentGuestValuesString ? JSON.parse(paymentGuestValuesString) : null;
            if ((_a = confirmValuesContext.confirmValues) === null || _a === void 0 ? void 0 : _a.suite) {
                fillPaymentData(confirmValuesContext.confirmValues, paymentGuestValues, true);
            }
            else {
                (0, helpers_1.handleCleanBookingStorage)();
                history.push(RoutesPaths_1.routesPaths.root);
            }
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!abandonedCartToken) {
            // Atualiza o timer do booking
            const bookingIdString = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
            const { isFromBookingInChart } = confirmValuesContext.confirmValues;
            if (bookingIdString) {
                setBookingTimer(bookingIdString, isFromBookingInChart);
            }
            else {
                history.push(RoutesPaths_1.routesPaths.root);
                window.location.reload();
            }
        }
    }, [abandonedCartToken]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (loading) {
            (_a = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                setMessageloading(secondMessageLoadingPayment);
            }, 2500);
            setTimeout(() => {
                setMessageloading(thirdMessageLoadingPayment);
            }, 5000);
        }
        else {
            setMessageloading(firstMessageLoadingPayment);
        }
    }, [loading]);
    return (react_1.default.createElement("div", { className: "Payment", ref: paymentRef },
        react_1.default.createElement("div", { className: "spin-animation" },
            loading && (react_1.default.createElement("div", { className: "spin-animation-content" },
                react_1.default.createElement("div", { className: "spin-animation-content-icon" },
                    react_1.default.createElement("div", { className: "spin-animation-content-icon-component" })),
                react_1.default.createElement("div", { className: "spin-animation-content-text" },
                    react_1.default.createElement("span", null, messageLoading)))),
            react_1.default.createElement(antd_1.Col, { span: 24 },
                react_1.default.createElement(antd_1.Row, { justify: "space-between", className: "total-sticky-mobile" },
                    react_1.default.createElement(Text_1.default, { size: 30, bold: true }, "Total \u00E0 vista"),
                    react_1.default.createElement(Text_1.default, { bold: true, size: 20 },
                        `R$ `,
                        react_1.default.createElement(Text_1.default, { size: 30, bold: true }, (0, format_1.getFormattedDouble)(confirmValuesContext.confirmValues.totalPrice) || react_1.default.createElement(icons_1.LoadingOutlined, null)))),
                react_1.default.createElement(PaymentStyled_1.ContainerBody, { disabled: disabled },
                    react_1.default.createElement(antd_1.Col, { xs: 0, sm: 0, lg: 24 },
                        react_1.default.createElement(PaymentStyled_1.DividerTitle, { orientation: "left" },
                            react_1.default.createElement("b", null, "Pagamento "),
                            "da hospedagem"),
                        startTimer &&
                            (reserveInfo.discountPercent && reserveInfo.discountPercent > 0 ? (react_1.default.createElement("div", { style: { display: 'inline-block', fontWeight: 500 } },
                                react_1.default.createElement("span", null, "Voc\u00EA tem "),
                                react_1.default.createElement("span", { style: { color: '#c31c4a' } },
                                    react_1.default.createElement(TimeLeft_1.default, { timeLeftServer: timeLeftServer, textInformation: "", startTimer: startTimer }),
                                    "\u00A0minutos"),
                                react_1.default.createElement("span", null, " para garantir esta reserva com "),
                                react_1.default.createElement("span", { style: { color: '#c31c4a' } }, `${reserveInfo.discountPercent}% de desconto`))) : (react_1.default.createElement("div", { style: { fontWeight: 500 } },
                                react_1.default.createElement("span", null, "Voc\u00EA tem "),
                                react_1.default.createElement("span", { style: { color: '#c31c4a' } },
                                    react_1.default.createElement(TimeLeft_1.default, { timeLeftServer: timeLeftServer, textInformation: "", startTimer: startTimer }),
                                    "\u00A0minutos"),
                                react_1.default.createElement("span", null, " para garantir esta reserva")))),
                        react_1.default.createElement(underline_1.default, null)),
                    react_1.default.createElement(DisplayEmailAndLogin_1.default, { readOnly: userLogged, display: !userLogged, form: formSuite, onChange: Active, inputValue: userEmail }),
                    react_1.default.createElement(antd_1.Divider, null),
                    react_1.default.createElement(PaymentStyled_1.DisableDiv, { disabled: disableForm },
                        react_1.default.createElement(antd_1.Form, { name: "form-reserva", form: formSuite, initialValues: {
                                suites: arrayID.map(id => ({
                                    id,
                                    guests: Array((reserveInfo.guestsQty || 2) - 1)
                                        .fill(0)
                                        .map((guestId, index) => ({
                                        id: index,
                                    })),
                                })),
                            } },
                            react_1.default.createElement(antd_1.Row, { style: {
                                    marginBottom: '15px',
                                }, justify: "space-between" },
                                react_1.default.createElement(antd_1.Col, { xs: 24, sm: 24, lg: 9 },
                                    react_1.default.createElement(PaymentStyled_1.SubTitle, { level: 4 }, "Preencha os dados dos h\u00F3spedes"))),
                            react_1.default.createElement(antd_1.Row, { id: "SuiteCollapse-container" },
                                react_1.default.createElement(antd_1.Form.List, { name: "suites" }, fields => (react_1.default.createElement(react_1.default.Fragment, null, fields === null || fields === void 0 ? void 0 : fields.map(field => (react_1.default.createElement(SuiteTabs_1.default, { key: field.key, form: formSuite, field: field, guestsQty: (reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.guestsQty) || 1, formsWithError: formWithError, setRefundProtectEnabled: setRefundProtectEnabled, setShowRefundComponent: setShowRefundComponent, setNeedDebitPhoneBR: setNeedDebitPhoneBR, setNeedPaymentDocCPF: setNeedPaymentDocCPF, initialFilledGuestsNumber: filledGuestsNumber })))))))),
                        react_1.default.createElement(antd_1.Divider, null),
                        refundProtectEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(antd_1.Form, { form: formSuite },
                                react_1.default.createElement(antd_1.Form.List, { name: "suites" }, fields => (react_1.default.createElement(react_1.default.Fragment, null, fields === null || fields === void 0 ? void 0 : fields.map(field => (react_1.default.createElement(RefundProtect_1.RefundProtect, { formKey: "suites", field: 0, setPaymentEnabled: setPaymentEnabled, refundProtectEnabled: refundProtectEnabled, showRefundComponent: showRefundComponent, setShowRefundComponent: setShowRefundComponent }))))))),
                            react_1.default.createElement(antd_1.Divider, null))),
                        react_1.default.createElement(PaymentStyled_1.ContainerPayment, { disabled: paymentEnabled },
                            react_1.default.createElement(antd_1.Form, { form: formPayment },
                                react_1.default.createElement(PaymentForm_1.default, { form: formPayment, needDebitPhoneBR: needDebitPhoneBR, needPaymentDocCPF: needPaymentDocCPF })),
                            react_1.default.createElement(antd_1.Divider, null),
                            react_1.default.createElement(antd_1.Form, { form: formSuite },
                                react_1.default.createElement(PaymentStyled_1.SubTitle, { style: { marginTop: '25px' }, level: 4 }, "Termo de Uso"),
                                react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                                    react_1.default.createElement(antd_1.Col, { span: 16 },
                                        react_1.default.createElement(PaymentStyled_1.FormItemFormulary, { valuePropName: "checked", name: "requiredCheckbox", rules: [
                                                {
                                                    validator: (_, value) => value ? Promise.resolve() : Promise.reject(Error('Aceite os termos de uso.')),
                                                },
                                            ] },
                                            react_1.default.createElement(PaymentStyled_1.CheckboxStyled, null,
                                                react_1.default.createElement("div", null,
                                                    react_1.default.createElement("span", null, "Li e aceito as condi\u00E7\u00F5es da \u00A0"),
                                                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                            pathname: RoutesPaths_1.routesPaths.privacy,
                                                            state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                        } }, "pol\u00EDtica de privacidade,"),
                                                    "\u00A0",
                                                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                            pathname: RoutesPaths_1.routesPaths.cancel,
                                                            state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                        } }, "pol\u00EDtica de cancelamento,"),
                                                    "\u00A0",
                                                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                            pathname: RoutesPaths_1.routesPaths.terms,
                                                            state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                        } }, "termos de uso")))),
                                        react_1.default.createElement(PaymentStyled_1.FormItemFormulary, { valuePropName: "checked", name: "acceptOffers" },
                                            react_1.default.createElement(PaymentStyled_1.CheckboxStyled, null, "Quero receber ofertas, promo\u00E7\u00F5es exclusivas, cupons e novidades por e-mail.")),
                                        react_1.default.createElement(PaymentStyled_1.FormItemFormulary, { valuePropName: "checked", name: "acceptStoreData", rules: [
                                                {
                                                    validator: (_, value) => value
                                                        ? Promise.resolve()
                                                        : Promise.reject(Error('Permita que a 360 processe seus dados')),
                                                },
                                            ] },
                                            react_1.default.createElement(PaymentStyled_1.CheckboxStyled, null, "Eu permito que a 360 Su\u00EDtes armazene e processe meus dados pessoais."))),
                                    react_1.default.createElement(antd_1.Col, { xs: {
                                            span: 24,
                                            flex: '1',
                                        }, sm: {
                                            span: 24,
                                            flex: '1',
                                        }, lg: {
                                            span: 6,
                                        } },
                                        react_1.default.createElement("div", { style: {
                                                width: '100%',
                                                marginBottom: '50px',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                            } },
                                            react_1.default.createElement(antd_1.Button, { type: "primary", style: { textAlign: 'center' }, onClick: sendCheckout }, "Finalizar Reserva"))))))))),
            react_1.default.createElement(ModalPaymentErrorStyled_1.ModalGeneric, { title: "Ops!", width: "30%", backgroundColor: "#c31c4a", fontColor: "#ffff", visible: modalStateError, onOk: () => setModalStateError(!modalStateError), onCancel: () => setModalStateError(!modalStateError) },
                react_1.default.createElement(ModalPaymentErrorContent_1.default, { modalStateErrorDescription: modalStateErrorDescription })),
            react_1.default.createElement(ModalPaymentErrorStyled_1.ModalGeneric, { title: "Redirecionamento para Pagamento", width: "30%", showFooter: true, visible: modalStateRedirect, onOk: () => handleRedirectButton(), onCancel: () => setModalStateRedirect(!modalStateRedirect) },
                react_1.default.createElement(ModalRedirectPaymentContent_1.default, null)),
            react_1.default.createElement(ModalPaymentErrorStyled_1.ModalGeneric, { title: "Redirecionamento ambiente PIX", width: "30%", showFooter: true, visible: modalStateRedirectPix, onOk: () => handleRedirectButton(), onCancel: () => setModalStateRedirectPix(!modalStateRedirectPix) },
                react_1.default.createElement(ModalRedirectPaymentContent_1.default, { text: constants_1.TEXT_PIX })))));
};
exports.default = Payment;
